// tslint:disable:max-line-length

import React from 'react';

export const ActionMore = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.11,11V8.16H4.42V6.38H7.11V3.58H8.9v2.8h2.69V8.16H8.9V11Z" />
    </svg>
  );
};
